import { render, staticRenderFns } from "./list.vue?vue&type=template&id=19634324&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=19634324&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19634324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19634324')) {
      api.createRecord('19634324', component.options)
    } else {
      api.reload('19634324', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=19634324&scoped=true", function () {
      api.rerender('19634324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsVisible/list.vue"
export default component.exports